import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { UserAuthorityType } from 'entities/user/module'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import { Props, TypesPagesModuleRouterList } from '../../module'

import s from './styles.module.scss'

export const Blocks = ({
  active,
  isDevUser,
  authorityType,
  onClick,
}: Props) => {
  const { t } = useTranslation()

  return (
    <div className={s.container}>
      {TypesPagesModuleRouterList?.map((tab) => {
        if (!tab) return

        if (tab?.isForDevUsers && !isDevUser) return null

        if (
          authorityType &&
          tab?.hideForUserAuthorityType?.includes(
            authorityType as UserAuthorityType,
          )
        )
          return null

        return (
          <div
            key={tab.module}
            data-module={tab.module}
            className={s.block}
            onClick={() => onClick(tab.module)}
          >
            <div className={s.icon}>
              <AppIcon
                width={56}
                height={56}
                id={
                  tab?.newTabs?.[
                    active === tab.module ? 'activeIcon' : 'disabledIcon'
                  ] as AllIcons
                }
              />

              {tab?.isNew && (
                <span className={clsx('semi-bold-9', s.newTab)}>New!</span>
              )}
            </div>

            <p className={clsx('semi-bold-12', s.name)}>
              {t(tab?.newTabs?.name ?? '')}
            </p>
          </div>
        )
      })}
    </div>
  )
}
